module.exports = __webpack_public_path__ + "img/CAT_ETC.81003f03.svg";